<nav role="navigation" aria-labelledby="block-menu-hamburger-menu" id="block-menu-hamburger">
  <div id="hamburger-close"><i class="fa fa-times"></i></div>
  <ul class="menu navside">
    <li [class]="menuItem.children.length? 'expanded dropdownsidenav' : 'sidemenu-limenuitem'" *ngFor="let menuItem of menuList">

        <ng-container *ngIf="!menuItem.children.length">
            <!--mat-icon class="sidemenu-icon">{{menuItem.icon}}</mat-icon-->
            <a *ngIf="menuItem.route != null" [routerLink]="menuItem.route">{{menuItem.label}}</a>
            <a *ngIf="menuItem.href != null" [href]="menuItem.href" (click)="gotoPage($event, menuItem.href)">{{menuItem.label}}</a>
        </ng-container>

        <ng-container *ngIf="menuItem.children.length">
            <a class="accordion-toggle collapsed">{{menuItem.label}} <i class="fa fa-angle-down" aria-hidden="true"></i></a>
            <ul class="menu dropdownsidenav-menu sidemenu-matmenuclass">
                <ng-container *ngFor="let childL1 of menuItem.children">
                    <li *ngIf="!childL1.children.length" class="sidemenu-limenuitem">
                        <a *ngIf="childL1.route != null" [routerLink]="childL1.route" [title]="childL1.title">{{childL1.label}}</a>
                        <a *ngIf="childL1.href != null" [href]="childL1.href" [target]="childL1.behavior" [title]="childL1.title">{{childL1.label}}</a>
                        <a *ngIf="childL1.route2 != null" routerLink="viewcomp" [state]="{ url: childL1.route2 }" [title]="childL1.title2">{{childL1.label2}}</a>
                        <a *ngIf="childL1.href2 != null" [href]="childL1.href2" [target]="childL1.behavior2" [title]="childL1.title2">{{childL1.label2}}</a>
                    </li>

                    <ng-container *ngIf="childL1.children.length">
                    <li>
                            <!--mat-icon class="sidemenu-icon">{{childL1.icon}}</mat-icon-->
                            <a class="accordion-toggle collapsed">{{childL1.label}} <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                    </li>
                    <ul class="menu dropdownsidenav-menu sidemenu-matmenuclass">
                            <ng-container *ngFor="let childL2 of childL1.children">
                                <li *ngIf="!childL2.children.length" class="sidemenu-limenuitem">
                                    <a *ngIf="childL2.route != null" [routerLink]="childL2.route" [title]="childL2.title">{{childL2.label}}</a>
                                    <a *ngIf="childL2.href != null" [href]="childL2.href" [target]="childL2.behavior" [title]="childL2.title">{{childL2.label}}</a>
                                    <a *ngIf="childL2.route2 != null" routerLink="viewcomp" [state]="{ url: childL2.route2 }" [title]="childL2.title2">{{childL2.label2}}</a>
                                    <a *ngIf="childL2.href2 != null" [href]="childL2.href2" [target]="childL2.behavior2" [title]="childL2.title2">{{childL2.label2}}</a>
                                </li>
    
                                <ng-container *ngIf="childL2.children.length">
                                    <li>
                                        <!--mat-icon class="sidemenu-icon">{{childL2.icon}}</mat-icon-->
                                        <a class="accordion-toggle collapsed">{{childL2.label}} <i class="fa fa-angle-down" aria-hidden="true"></i></a>
                                    </li>
                                    <ul class="menu dropdownsidenav-menu sidemenu-matmenuclass">
                                        <ng-container *ngFor="let childL3 of childL2.children">
                                            <li class="sidemenu-limenuitem">
                                                <a *ngIf="childL3.route != null" [routerLink]="childL3.route" [title]="childL3.title">{{childL3.label}}</a>
                                                <a *ngIf="childL3.href != null" [href]="childL3.href" [target]="childL3.behavior" [title]="childL3.title">{{childL3.label}}</a>
                                                <a *ngIf="childL3.route2 != null" routerLink="viewcomp" [state]="{ url: childL3.route2 }" [title]="childL3.title2">{{childL3.label2}}</a>
                                                <a *ngIf="childL3.href2 != null" [href]="childL3.href2" [target]="childL3.behavior2" [title]="childL3.title2">{{childL3.label2}}</a>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </ng-container>
                            </ng-container>
                        </ul>
                    </ng-container>
                </ng-container>
            </ul>
        </ng-container>
    
    </li>
  </ul>
</nav>
